const userData = JSON.parse(localStorage.getItem("userData")) || {};

let defaultPath;

if (userData.signable_user_type === "VOSAP") {
  defaultPath = "/VOSAPUserDashboard";
} else {
  defaultPath = "/dashboard/server";
}

export default {
  defaultPath,
  basename: "/", // only at build time to set, like //
  layout: "vertical", // vertical, horizontal
  collapseMenu: false, // mini-menu
  layoutType: "menu-light", // menu-dark, menu-light
  headerBackColor: "", // header-blue, header-red, header-purple, header-info, header-dark
  fullWidthLayout: true,
  navFixedLayout: true,
  headerFixedLayout: true,
};
